<template>
  <!--div class="py-5 justify-content-center d-flex">
    <HollowDotsSpinner color="#082154"></HollowDotsSpinner>
  </div-->
    <vue-element-loading
      :active="true"
      :is-full-screen="fullScreen"
      spinner="ring"
      :size="size"
      background-color="rgba(255, 255, 255, 0.75)"
      color="#082154"
    />
</template>

<script>
//import { HollowDotsSpinner } from 'epic-spinners'
import VueElementLoading from "vue-element-loading";

export default {
  //components: { HollowDotsSpinner }
  components: { VueElementLoading },
  props: {
    fullScreen: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    size() {
      return (this.fullScreen ? 100 : 40).toString()
    }
  }
}
</script>
